import React from 'react'
import './ProjectCard.scss'
import ProjectCard from './ProjectCard'
import { Link } from 'react-router-dom'

function ProjectGrid() {
    return (


        <div className='max-width-projectgrid' >

            <h3 className='bottom-2xl'>Selected work.</h3>

            <div className='project-grid'>


                <div id='card1' className='projectcard'>
                    <Link to="/Du" onClick={() => window.scrollTo(0, 0)}>
                        <ProjectCard />
                    </Link>
                </div>
                <div id='card2' className='projectcard'>
                    <Link to="/Menu">
                        <ProjectCard />
                    </Link>
                </div>

                <div id='card3' className='projectcard'>
                    <Link to="/DS">
                        <ProjectCard />
                    </Link>
                </div>

                <div id='card4' className='projectcard'>
                    <Link to="/ERP">
                        <ProjectCard />
                    </Link>
                </div>




            </div>


        </div>


    )
}

export default ProjectGrid